module.exports = __webpack_public_path__ + "img/yuangongyeji.959754ab.png";